<template>
  <v-col cols="12">
    <v-col cols="12">
      <v-card
        class="rounded-0 pa-7"
        elevation="0"
      >
        <v-card-title class="titreBoite">
          {{$tc("accueil.BoiteOffreRegional.TitreOffreRegional")}}
        </v-card-title>

        <div v-html="appStore.texteDynamique.BlocTexte1"></div>
      </v-card>
    </v-col>
  </v-col>
</template>

<script>
import useAppStore from '@/store/appStore';

export default {
  name: 'BoiteOffreRegional',
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  computed: {

  },
  created() {
  },
};

</script>
